import { Link } from '@redis-ui/components';
import { InputLabelWithInfoProps } from './InputLabelWithInfo.types';
import * as S from './InputLabelWithInfo.style';

import HoverableInfoIcon from '../../HoverableInfoIcon/HoverableInfoIcon';
import { useTranslation } from 'react-i18next';
import { i18translation } from 'locale/translations/i18NsPaths';

const InputLabelWithInfo = ({
  label,
  testId,
  hoverableInfoIconProps,
  readMore,
  className,
  optional,
  htmlFor
}: InputLabelWithInfoProps) => {
  const keyPrefix = i18translation.billingAndPayments.tabs.payments.addEditCCDialog;
  const { t } = useTranslation();

  return (
    <S.Container {...{ className }}>
      <S.InputLabel data-testid={`readonlylabel--${testId}`} htmlFor={htmlFor || testId}>
        <span>
          {label}
          {optional && <S.Optional>{t(keyPrefix.optional)}</S.Optional>}
        </span>
      </S.InputLabel>
      {hoverableInfoIconProps && <HoverableInfoIcon size="L" {...hoverableInfoIconProps} />}
      {readMore?.link && (
        <Link
          href={readMore.link}
          data-testid={readMore.testId}
          variant="inline"
          external
          style={{ alignSelf: 'center' }}
        >
          {readMore.text || ' '}
        </Link>
      )}
    </S.Container>
  );
};

export default InputLabelWithInfo;
